import {
    Component,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChild,
    ViewChildren,
    ChangeDetectionStrategy
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { EmergencyAgentAccessService } from './emergency-agent-access.service';
import { GeoLocationService } from 'app/core/api/geo-location.service';
import {
    GeoLocation,
    IGeoLocation,
} from 'app/modules/shared/models/geo-location.model';
import { GeoFence, IGeoFence } from 'app/modules/shared/models/geo-fence.model';
import { UserManagementService } from 'app/core/api/user.service';
import { AdditionalUserDataService } from 'app/core/api/additional-user-data.service';
import { IGenericDTO } from 'app/modules/shared/models/generic-dto.model';
import { IEmergency } from 'app/modules/shared/models/emergency.model';
import { User } from 'app/modules/shared/models/user-management.model';
import { HttpResponse } from '@angular/common/http';
import { EmergencyHttpService } from 'app/core/api/emergency.service';
import { IGroupChatMessage } from 'app/modules/shared/models/group-chat-message.model';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import {
    GoogleMap,
    MapAdvancedMarker,
    MapCircle,
    MapGeocoder,
    MapInfoWindow,
    MapMarker,
    MapPolyline,
} from '@angular/google-maps';
import { GroupChatComponent } from './group-chat/group-chat.component';
import { DateTime } from 'luxon';
import { MatIcon } from '@angular/material/icon';
import { CommonService } from 'app/modules/shared/services/common';
import { Subject, take, takeUntil } from 'rxjs';
import { escapeHtml } from 'app/modules/shared/models/common';
import { addressParts, firstGeocoderResult, isSafeToken, tokenFromHistoryState, tokenFromParams } from 'app/modules/shared/utils/third-party-data';

const homeRed = `<svg xmlns="http://www.w3.org/2000/svg" fill="#8D1010" viewBox="0 0 24 24" stroke-width="2" stroke="#8D1010" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
</svg>
`;

const homeGreen = `<svg xmlns="http://www.w3.org/2000/svg" fill="#113523" viewBox="0 0 24 24" stroke-width="2" stroke="#113523" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
</svg>
`;
const parser = new DOMParser();
const pinHomeRed = parser.parseFromString(
    homeRed,
    'image/svg+xml',
).documentElement;
const pinHomeGreen = parser.parseFromString(
    homeGreen,
    'image/svg+xml',
).documentElement;

@Component({
    selector: 'app-emergency-agent-access',
    imports: [
        TranslocoModule,
        MatSidenavModule,
        MatButtonModule,
        MatIcon,
        GoogleMap,
        MapAdvancedMarker,
        MapInfoWindow,
        MapCircle,
        MapPolyline,
        GroupChatComponent,
    ],
    templateUrl: './emergency-agent-access.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './emergency-agent-access.component.scss'
})
export class EmergencyAgentAccessComponent implements OnInit, OnDestroy {
    // @ViewChild('messageInput') messageInput: ElementRef;
    drawerMode: 'over' | 'side' = 'over';
    drawerOpened: boolean = false;
    @ViewChild(GoogleMap, { static: false }) map: GoogleMap;

    @ViewChildren(MapInfoWindow)
    infoWindowsView!: QueryList<MapInfoWindow>;

    @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;

    groupChatMessages?: IGroupChatMessage[];

    label1 = {
        color: '#000',
        fontSize: '28px',
        fontWeight: '600',
        text: '1',
    };

    label2 = {
        color: '#000',
        fontSize: '12px',
        fontWeight: '600',
        text: '2',
    };

    label3 = {
        color: '#000',
        fontSize: '12px',
        fontWeight: '600',
        text: '3',
    };

    label4 = {
        color: '#000',
        fontSize: '12px',
        fontWeight: '600',
        text: '4',
    };

    label5 = {
        color: '#000',
        fontSize: '12px',
        fontWeight: '600',
        text: '5',
    };

    // mIcon = {
    //     path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
    //     fillOpacity: 1,
    //     fillColor: '#6B5',
    //     strokeOpacity: 1,
    //     strokeWeight: 1,
    //     strokeColor: '#333',
    //     scale: 12,
    // };

    token = '-1';
    isLoading = false;
    isLoadingGps = false;
    isRequestingNewLocation = false;
    isLoadingGeofence = false;
    userWithEmergency = new User();
    isValidToken = false;
    // center: google.maps.LatLngLiteral = { lat: 51.1657, lng: 10.4515 };

    options: google.maps.MapOptions = {
        // center: { lat: 24.85, lng: 67.04 },
        // center: { lat: -31, lng: 147 },
        center: { lat: 48.137589261381386, lng: 11.575224495351572 },
        mapId: 'DEMO_MAP_ID',
        zoom: 17,
        mapTypeId: 'satellite',
    };

    // markerOptions: google.maps.MarkerOptions = { draggable: false };
    markerOptions: google.maps.marker.AdvancedMarkerElementOptions;

    circleOptions: google.maps.CircleOptions;
    geofenceCircleOptions: google.maps.CircleOptions = { fillColor: 'green' };
    markerPositions: google.maps.LatLngLiteral[] = [];
    markerPositionsTmp: google.maps.LatLngLiteral[] = [];
    markerGeofenceCenters: google.maps.LatLngLiteral[] = [];
    markerGeofenceCentersTmp: google.maps.LatLngLiteral[] = [];
    circlePositions: google.maps.Circle[] = [];
    circleGeofences: google.maps.Circle[] = [];
    openedMapInfoWindow?: MapInfoWindow;
    openedMapInfoWindowGeofence?: MapInfoWindow;
    lastGeolocations: GeoLocation[] | null = [];
    listGeofences: GeoFence[] | null = [];
    infoContent!: string;
    showAccuracy = true;
    selectedMarkerIndex = -1;
    selectedRowIndex = -1;
    userEmergencyId?: IGenericDTO;
    emergency?: IEmergency;

    // possible values for recallUserResult and recallAgentResult:
    // -2: default value if there was no call to reCallUserWithEmergency()
    // -1: no current emergency for this user
    // 0: user was called again to join the conf call
    // 1: use is already in the conf call
    reEstablishTheCallResult = -22;

    // possible values for requestGeolocationUpdate:
    // -2: default value if there was no call to updateGeolocationDisplay()
    // -1: no current emergency for this user
    // 0: geolocation update was requested successfully
    // 1: Please wait at least 1 minute between each 2 geo location update requests
    // 2: no mobilityConfig for this user
    updateGeolocationDisplayResult = -2;
    lastConfigurableBPDays = 90;

    // redMarker = () =>
    //     new google.maps.marker.PinElement({
    //         background: '#8D1010',
    //         borderColor: '#8D1010',
    //         glyphColor: 'white',
    //     });

    // darkGreenMarker = () =>
    //     new google.maps.marker.PinElement({
    //         background: '#113523',
    //         borderColor: '#113523',
    //         glyphColor: 'white',
    //     });

    // lightGreenMarker = () =>
    //     new google.maps.marker.PinElement({
    //         background: '#7FB591',
    //         borderColor: '#7FB591',
    //         glyphColor: 'white',
    //     });

    isHomeLocationAdded = false;
    homeAddress = null;
    homeLocation = null;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private userService: UserManagementService,
        private emergencyAgentAccessService: EmergencyAgentAccessService,
        private geoLocationService: GeoLocationService,
        // private geoFenceService: GeoFenceService,
        private additionalUserDataService: AdditionalUserDataService,
        protected emergencyService: EmergencyHttpService,
        private _geocoder: MapGeocoder,
        private _commonService: CommonService,
    ) {}

    ngOnInit(): void {
        this.activatedRoute.queryParams
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((params) => {
                // new links carry the token in the fragment ("#eaa="), which no server receives; earlier ones in the query
                const linkToken = tokenFromParams(this.activatedRoute.snapshot.fragment, 'eaa') ?? params.eaa;
                // after a reload the address no longer has it; the history entry of this tab does
                const token = linkToken ?? tokenFromHistoryState(window.history.state, 'eaa') ?? undefined;
                if (token === undefined) {
                    this.emergencyAgentAccessService
                        .getEaaTokenSubject()
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe((eaaToken) => {
                            if (!eaaToken) {
                                this.reload();
                            } else {
                                this.token = eaaToken;
                                this.isValidEmergencyAgentToken();
                            }
                        });
                } else if (isSafeToken(token)) {
                    // taking the token off the address bar runs this again
                    if (token !== this.token) {
                        this.token = token;
                        this.isValidEmergencyAgentToken();
                    }
                    if (linkToken !== undefined) {
                        this.takeTokenOffTheAddressBar(token);
                    }
                } else {
                    // a token that is not well-formed is treated like an invalid token (BSI O.TrdP_7)
                    this.reload();
                }
            });
    }

    /**
     * The token leaves the address bar, so that it is not on the screen and not in the browser history (BSI O.Source_11).
     * The state of the history entry keeps it for a reload of this page in this tab.
     */
    private takeTokenOffTheAddressBar(token: string): void {
        this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { eaa: null },
            queryParamsHandling: 'merge',
            replaceUrl: true,
            state: { eaa: token },
        });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    requestGeolocationUpdate() {
        return this.emergencyService.requestGeolocationUpdate(this.token);
    }

    getGeocodeWithLocation(location: google.maps.LatLngLiteral) {
        return this._geocoder.geocode({
            location,
        });
    }

    addMarker(lastGeolocation: IGeoLocation): void {
        const marker = new google.maps.LatLng(
            lastGeolocation.latitude ? lastGeolocation.latitude : 0,
            lastGeolocation.longitude ? lastGeolocation.longitude : 0,
        );

        const circle = new google.maps.Circle();
        const markerCenter: google.maps.LatLngLiteral = {
            lat: lastGeolocation.latitude ? lastGeolocation.latitude : 0,
            lng: lastGeolocation.longitude ? lastGeolocation.longitude : 0,
        };
        circle.setCenter(markerCenter);
        circle.setRadius(
            lastGeolocation.accuracy ? lastGeolocation.accuracy : 0,
        );

        const jsonMarker = marker.toJSON();
        this.markerPositionsTmp.push(jsonMarker);
        this.circlePositions.push(circle);
        // this.center = jsonMarker;
    }

    addGeofence(geoFence: IGeoFence): void {
        const circle = new google.maps.Circle();
        const geofenceCenter: google.maps.LatLngLiteral = {
            lat: geoFence.latitude ? geoFence.latitude : 0,
            lng: geoFence.longitude ? geoFence.longitude : 0,
        };
        circle.setCenter(geofenceCenter);
        circle.setRadius(
            geoFence.movementRadiusInMeter ? geoFence.movementRadiusInMeter : 0,
        );
        this.circleGeofences.push(circle);

        const markerGeofenceCenter = new google.maps.LatLng(
            geoFence.latitude ? geoFence.latitude : 0,
            geoFence.longitude ? geoFence.longitude : 0,
        );
        const jsonGeofenceCenter = markerGeofenceCenter.toJSON();
        this.markerGeofenceCentersTmp.push(jsonGeofenceCenter);
    }

    updateGeolocationDisplay(): void {
        this.geoLocationService
            .sendGeolocationUpdateRequestByEmergencyAgentToken(this.token)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result) => {
                this.updateGeolocationDisplayResult = result;
                setTimeout(() => {
                    this.updateGeolocationDisplayResult = -2;
                }, 10000);

                this.isRequestingNewLocation = true;
                setTimeout(() => {
                    this.updateGps();
                    this.isRequestingNewLocation = false;
                }, 8000);
            });
    }

    displayHealthReport(): void {
        this.emergencyAgentAccessService.queryAllReportDataAndDownloadReportByEmergencyAgentToken(
            this.token,
            this.lastConfigurableBPDays,
        );
    }

    removeDuplicateLocations() {
        this.markerPositions.forEach((location: any, index) => {
            location.isDuplicate = false;
            if (index) {
                location.isDuplicate = this.coordinatesAreClose(
                    this.markerPositions[index - 1],
                    location,
                );
            }
        });

        const lastGeolocations: any = this.markerPositions.filter(
            (l: any) => !l.isDuplicate,
        );
        this.lastGeolocations = lastGeolocations;
    }

    updateGps(): void {
        this.isLoadingGps = true;
        this.markerPositions = [];
        this.markerPositionsTmp = [];
        this.circlePositions = [];
        this.markerGeofenceCenters = [];
        this.markerGeofenceCentersTmp = [];
        this.circleGeofences = [];

        this.geoLocationService
            .findLastLocationsByEmergencyAgentToken(this.token)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((received) => {
                this.isLoadingGps = false;
                // for (const lastGeolocation of this.lastGeolocations!) {
                //     this.addMarker(lastGeolocation);
                // }
                // this.markerPositions = this.markerPositionsTmp;
                let locations = received.body;
                if (!locations?.length) {
                    return;
                    // locations = [
                    //     { latitude: 24.85, longitude: 67.04 },
                    //     { latitude: -31, longitude: 147 },
                    // ];
                }
                this.markerPositions = locations.map((l) => {
                    return {
                        lat: l.latitude,
                        lng: l.longitude,
                        ...l,
                    };
                });

                this.removeDuplicateLocations();
                const { latitude, longitude, accuracy } =
                    this.lastGeolocations[0];
                const position = { lat: latitude, lng: longitude };
                this.options.center = position;
                this.circleOptions = {
                    strokeColor: '#000000',
                    strokeOpacity: 0.9,
                    strokeWeight: 2,
                    fillColor: '#000000',
                    fillOpacity: 0.2,
                    // editable: true,
                    // draggable: true,
                    // clickable: true,
                    radius: accuracy ? accuracy : 0,
                    center: position,
                };
                this.map.panTo(position);
                setTimeout(() => this.createMarkers(), 400);
            });

        // this.geoFenceService
        //     .findGeofencesByEmergencyAgentToken(this.token)
        //     .subscribe(
        //         (received) => {
        //             this.isLoadingGeofence = false;
        //             this.listGeofences = received.body;
        //             console.log(this.listGeofences);
        //             for (const geofence of this.listGeofences!) {
        //                 this.addGeofence(geofence);
        //             }
        //             this.markerGeofenceCenters = this.markerGeofenceCentersTmp;
        //         },
        //         () => (this.isLoadingGeofence = false)
        //     );
    }

    createMarkers() {
        this.lastGeolocations?.forEach((location: any, index) => {
            // if (!google.maps?.marker?.PinElement) {
            //     return;
            // }
            console.log(index);
            const location_dark_red = new google.maps.marker.PinElement({
                background: '#8D1010',
                borderColor: '#8D1010',
                glyphColor: 'white',
            });
            const location_dark_green = new google.maps.marker.PinElement({
                background: '#113523',
                borderColor: '#113523',
                glyphColor: 'white',
            });
            const location_light_green = new google.maps.marker.PinElement({
                background: '#7FB591',
                borderColor: '#7FB591',
                glyphColor: 'white',
            });
            let markerPin: google.maps.marker.PinElement = location_dark_green;
            if (index === 0) {
                // markerPin = location_dark_green;
                markerPin = location_dark_red;
            } else {
                if (location.accuracy < 20) {
                    markerPin = location_dark_green;
                } else {
                    markerPin = location_light_green;
                }
            }
            location.content = markerPin.element;
            location.title = index;
            console.log('Marker');
        });
        this.addHomeLocationOnMap();
    }

    reEstablishTheCall(): void {
        this.isLoading = true;

        this.emergencyAgentAccessService
            .reEstablishTheCall(this.token)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((received) => {
                this.isLoading = false;
                this.reEstablishTheCallResult = received;
                setTimeout(() => {
                    this.reEstablishTheCallResult = -22;
                }, 10000);
            });
    }

    loadUserWithEmergency(): void {
        this.isLoading = true;

        this.userService
            .findByEmergencyAgentToken(this.token)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((received) => {
                this.isLoading = false;
                this.userWithEmergency = received;

                this.requestGeolocationUpdate()
                    .pipe(take(1))
                    .subscribe(() => {
                        this.updateGps();
                        this.loadChats();
                        this.loadUserEmergencyId();
                        this.loadEmergency();

                        setInterval(() => {
                            this.updateGps();
                            this.loadChats();
                        }, 60000);
                    });
            });

        this.userService
            .getEmergencyAgentAddressWithToken(this.token)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((address) => {
                this.homeAddress = address;
                if (this.homeAddress.latitude && this.homeAddress.longitude) {
                    this.homeLocation = {
                        ...address,
                        lat: address.latitude,
                        lng: address.longitude,
                        // recordedAt: new Date().toISOString(),
                    };
                    this.addHomeLocationOnMap();
                } else {
                    this.getLocationWithAddress();
                }
            });
    }

    isValidEmergencyAgentToken(): void {
        this.isLoading = true;
        this.emergencyAgentAccessService
            .isValidEmergencyAgentToken(this.token)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (res2) => {
                    this.isValidToken = res2?.valid === true;
                    if (this.isValidToken) {
                        this.loadUserWithEmergency();
                    } else {
                        this.reload();
                    }
                },
                error: () => {
                    this.reload();
                },
            });
    }

    // mapMarkedClicked(marker: MapAdvancedMarker, windowIndex: number): void {
    //     this.selectedMarkerIndex = windowIndex;
    //     this.openInfoWindow(marker, windowIndex);

    //     // const nearbyMarkers = this.getNearbyMarkers(marker, 2);
    //     // for (const m of nearbyMarkers) {
    //     //   // alert(m.lat.toString() + ";" + m.lng.toString());
    //     // }

    //     this.selectedRowIndex = windowIndex;
    // }

    // getNearbyMarkers(marker: MapMarker, radius: number): google.maps.LatLngLiteral[] {
    //   const nearbyMarkers: google.maps.LatLngLiteral[] = [];

    //   for (const m of this.markerPositions) {
    //     const distance = google.maps.geometry.spherical.computeDistanceBetween(
    //       new google.maps.LatLng(marker.getPosition()!.lat(), marker.getPosition()!.lng()),
    //       new google.maps.LatLng(m.lat, m.lng)
    //       );

    //     if (distance <= radius) {
    //       nearbyMarkers.push(m);
    //     }
    //   }
    //   return nearbyMarkers;
    // }

    onMarkerClick(marker: MapAdvancedMarker, location): void {
        if (this.openedMapInfoWindow) {
            this.openedMapInfoWindow.close();
        }
        this.infoContent = '';
        const accuracy = location.accuracy ? location.accuracy : '';
        const recordedAt = location.recordedAt ? location.recordedAt : '';
        const lat = location ? location.latitude : '';
        const lng = location ? location.longitude : '';
        // ? DateTime.fromISO(recordedAt).toFormat('D MMM yyyy HH:mm:ss')
        const formattedDate = recordedAt
            ? DateTime.fromISO(recordedAt).toFormat('DD MM yyyy hh:mm:ss')
            : '';

        const name =
            this.userWithEmergency.firstName +
            ' ' +
            this.userWithEmergency.lastName;
        let street = null;
        this.getGeocodeWithLocation({
            lat: location.latitude,
            lng: location.longitude,
        })
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ results }) => {
                // The geocoder result comes from Google Maps: validate it before it is used (BSI O.TrdP_7)
                let address = '';
                const geocoded = firstGeocoderResult(results);
                if (geocoded?.formattedAddress) {
                    const parts = addressParts(geocoded);
                    address = parts.address;
                    street = parts.street;
                }
                this.infoWindow?.infoWindow?.setContent(`
                <div>
                    <div class="text-lg font-semibold">${escapeHtml(name)}</div>
                    ${recordedAt ? formattedDate + '<br/>' : ''}
                    ${street ? escapeHtml(street) + '</br>' : ''}
                    ${escapeHtml(address) + '</br>'}
                    ${
                        'Breite/Längengrad: ' +
                        lat!.toString() +
                        '/' +
                        lng!.toString() +
                        '  <br/>'
                    }
                    ${
                        accuracy
                            ? 'Genauigkeit: ' + accuracy.toString() + ' m <br/>'
                            : ''
                    }
                    <div>Position:  <a class="underline"
                                    href="https://www.google.com/maps/search/?api=1&query=${
                                        location.latitude
                                    },${location.longitude}"
                                    target="_blank">
                                    ${location.latitude},${location.longitude}
                                    </a>
                    </div>
                    </br>
                    <button id="nearest-btn" class="mb-2 bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded-full" type="button">
                        ${this._commonService.t('NEAREST-EMERGENCY-STATION')}
                    </button>
                    <div id="nearest-emergency"></div>
                </div>
                `);

                // this.openedMapInfoWindow = window;
                this.infoWindow.open(marker);

                setTimeout(() => {
                    const button = document.getElementById('nearest-btn');
                    if (!button) {
                        return;
                    }
                    button.onclick = () => {
                        const params = {
                            latitude: lat,
                            longitude: lng,
                        };
                        this.emergencyService
                            .getNearestToGeolocation(params)
                            .pipe(takeUntil(this._unsubscribeAll))
                            .subscribe((res) => {
                                const nearestEmergencyDiv =
                                    document.getElementById(
                                        'nearest-emergency',
                                    );
                                const nearestEmergencyDivContent = `
                                <div> ${escapeHtml(res.name)}</div>
                                <div> ${escapeHtml(res.areaType)}</div>
                                <div> ${escapeHtml(res.operator)}</div>
                                <div> ${escapeHtml(res.address)}</div>
                                <div> ${escapeHtml(res.zipCode)} ${escapeHtml(res.city)}</div>
                                 ${
                                     res.phoneNumber1
                                         ? '<div>' +
                                           escapeHtml(res.phoneNumber1) +
                                           '</div>'
                                         : ''
                                 }
                                 ${
                                     res.phoneNumber2
                                         ? '<div>' +
                                           escapeHtml(res.phoneNumber2) +
                                           '</div>'
                                         : ''
                                 }
                                 ${
                                     res.phoneNumber3
                                         ? '<div>' +
                                           escapeHtml(res.phoneNumber3) +
                                           '</div>'
                                         : ''
                                 }
                                <div> ${escapeHtml(res.email)}</div>
                                <div> <a  href="https://${escapeHtml(
                                    res.website,
                                )}" target="_blank">${escapeHtml(res.website)}</a></div>
                                <div> <a class="underline"
                                                    href="https://www.google.com/maps/search/?api=1&query=${
                                                        res.latitude
                                                    },${res.longitude}"
                                                    target="_blank">${
                                                        res.latitude
                                                    },${res.longitude}</a>
                                </div>
                           `;
                                nearestEmergencyDiv.innerHTML =
                                    nearestEmergencyDivContent;
                            });
                    };
                }, 500);
            });
    }

    handleLinkMarkerClick(indexClicked: number): void {
        // Do something with the variable
        // console.log('Link clicked with variable:', myVariable);
        alert(indexClicked);
    }

    openInfoWindowGeoFence(marker: MapMarker, windowIndex: number): void {
        if (this.openedMapInfoWindowGeofence) {
            this.openedMapInfoWindowGeofence.close();
        }

        this.infoContent = '';
        this.infoWindowsView.forEach((window: MapInfoWindow) => {
            const geofence = this.listGeofences
                ? this.listGeofences[windowIndex]
                : null;
            const locationName = geofence ? geofence.locationName : '';
            this.infoContent = locationName
                ? 'Standortnamen: ' + locationName + '<br/>'
                : '';
            this.openedMapInfoWindow = window;
            window.open(marker);

            return;
        });
    }

    getMarkerLabel(markerNumber: number, allMarkerNumber: number): any {
        if (allMarkerNumber >= 5) {
            if (markerNumber === 0) {
                return this.label5;
            } else if (markerNumber === 1) {
                return this.label4;
            } else if (markerNumber === 2) {
                return this.label3;
            } else if (markerNumber === 3) {
                return this.label2;
            } else {
                return this.label1;
            }
        } else if (allMarkerNumber === 4) {
            if (markerNumber === 0) {
                return this.label4;
            } else if (markerNumber === 1) {
                return this.label3;
            } else if (markerNumber === 2) {
                return this.label2;
            } else {
                return this.label1;
            }
        } else if (allMarkerNumber === 3) {
            if (markerNumber === 0) {
                return this.label3;
            } else if (markerNumber === 1) {
                return this.label2;
            } else {
                return this.label1;
            }
        } else if (allMarkerNumber === 2) {
            if (markerNumber === 0) {
                return this.label2;
            } else {
                return this.label1;
            }
        } else if (allMarkerNumber === 1) {
            return this.label1;
        }
    }

    getLocationWithAddress() {
        const patientAddress = this.homeAddress;
        if (!patientAddress) {
            return;
        }
        const address =
            (patientAddress.street || '') +
            ' ' +
            (patientAddress.streetNumber || '') +
            ' ' +
            (patientAddress.zip || '') +
            ' ' +
            (patientAddress.city || '') +
            ' ' +
            (patientAddress.district || '') +
            ' ' +
            (patientAddress.country || '') +
            ' ' +
            (patientAddress.addressSuffix || '');
        console.log('address: ', address);
        if (
            !address ||
            !(
                patientAddress.street &&
                patientAddress.streetNumber &&
                patientAddress.zip &&
                patientAddress.city
            )
        ) {
            return;
        }
        return this._geocoder
            .geocode({
                address,
            })
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ results }) => {
                // Position and address come from Google Maps: use them only when they are valid (BSI O.TrdP_7)
                const geocoded = firstGeocoderResult(results);
                if (geocoded?.position) {
                    const position = {
                        lat: geocoded.position.lat,
                        lng: geocoded.position.lng,
                        latitude: geocoded.position.lat,
                        longitude: geocoded.position.lng,
                    };
                    this.homeLocation = {
                        ...position,
                        address: geocoded.formattedAddress,
                        // recordedAt: new Date().toISOString(),
                    };

                    this.addHomeLocationOnMap();
                    // if (!this.patientLocations?.length) {
                    //     const { lat, lng } = position;
                    //     this.position = { lat, lng };
                    //     this.initMap();
                    // }
                } else {
                    this.homeLocation = null;
                }
            });
    }

    addHomeLocationOnMap() {
        // if (this.homeLocation && !this.isHomeLocationAdded) {
        if (this.homeLocation) {
            if (this.lastGeolocations?.length) {
                const lastLocation =
                    this.lastGeolocations[this.lastGeolocations.length - 1];
                const isHome = this.coordinatesAreClose(
                    this.homeLocation,
                    lastLocation,
                );
                const homeIcon = isHome ? pinHomeGreen : pinHomeRed;
                this.lastGeolocations.push({
                    ...this.homeLocation,
                    content: homeIcon,
                });
            } else {
                this.lastGeolocations.push({
                    ...this.homeLocation,
                    content: pinHomeGreen,
                });
            }
            this.isHomeLocationAdded = true;
        }
    }

    loadChats(): void {
        this.isLoading = true;

        // this.emergencyAgentAccessService
        //     .queryChatsByEmergencyAgentToken(this.token)
        //     .subscribe(
        //         (res: HttpResponse<IGroupChatMessage[]>) => {
        //             this.isLoading = false;
        //             this.groupChatMessages = res.body.reverse() ?? [];
        //         },
        //         () => {
        //             this.isLoading = false;
        //         }
        //     );

        this.emergencyAgentAccessService
            .queryChatsByEmergencyAgentToken(this.token)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (res: IGroupChatMessage[]) => {
                    this.isLoading = false;
                    // this.groupChatMessages = res.reverse() ?? [];
                },
                () => {
                    this.isLoading = false;
                },
            );
    }

    loadUserEmergencyId(): void {
        this.additionalUserDataService
            .getUserEmergencyIdByEmergencyAgentToken(this.token)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res: HttpResponse<IGenericDTO>) => {
                this.userEmergencyId = res.body ?? {};
            });
    }

    loadEmergency(): void {
        if (this.emergency == null) {
            this.emergencyService
                .getUserEmergencyIdByEmergencyAgentToken(this.token)
                .subscribe((res: HttpResponse<IEmergency>) => {
                    this.emergency = res.body ?? {};
                });
        }

        setTimeout(() => {
            this.isRequestingNewLocation = false;
            this.updateGps();
            this.isRequestingNewLocation = false;
            if (this.emergency == null) {
                this.loadEmergency();
            }
        }, 8000);
    }

    trackId(index: number, item: IGroupChatMessage): number {
        return item.id!;
    }

    sendMessage(message) {
        this.isLoading = true;
        this.emergencyAgentAccessService
            .createChatByEmergencyAgentToken(this.token, message)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                () => this.onSaveSuccess(),
                () => this.onSaveError(),
            );
    }

    // isGeolocationUpdateEnabled(): boolean {
    //     if (!this.emergency?.startedAt) {
    //         return false;
    //     }
    //     const currentTime = dayjs();
    //     const timeDifference = currentTime.diff(
    //         this.emergency.startedAt,
    //         'second'
    //     );
    //     return timeDifference > 80;
    // }

    protected onSaveSuccess(): void {
        this.loadChats();
        this.isLoading = false;
    }

    protected onSaveError(): void {
        this.isLoading = false;
    }

    /**
     * Open the Group chat
     */
    openGroupChat(): void {
        // Open the drawer
        this.drawerOpened = true;

        // Mark for check
        // this._changeDetectorRef.markForCheck();
    }

    reload() {
        // this.router.navigate(['']);
        window.location.href = '/';
    }

    private coordinatesAreClose(coord1, coord2, tolerance = 0.0001) {
        let deltaLat = Math.abs(coord1.latitude - coord2.latitude);
        let deltaLon = Math.abs(coord1.longitude - coord2.longitude);
        return deltaLat < tolerance && deltaLon < tolerance;
    }
}
